export const MILLISECONDS_IN_A_SECOND = 1000;
export const SECONDS_IN_A_HOUR = 3600;
